<template>
  <eg-b-sidebar
    id="metrics-teachers-sidebar"
    ref="sidebar"
    :visible="value"
    width="560px"
    right
    shadow
    lazy
    no-header
    backdrop
    backdrop-variant="transparent"
    sidebar-class="bg-white"
    @hidden="$emit('input', false)"
  >
    <template #default>
      <div class="metrics-teachers-sidebar">
        <div class="metrics-teachers-sidebar__header">
          <span class="heading-s">{{ $t("metrics.teachers") }}</span>
          <eg-button
            type="ordinary"
            icon="close"
            icon-size="medium"
            @click="$refs.sidebar.hide()"
          />
        </div>

        <div class="metrics-teachers-sidebar__body">
          <div v-if="isLoading" class="metrics-teachers-sidebar__loader">
            <eg-b-spinner variant="secondary" />
          </div>

          <eg-pv-table
            v-else
            :items="members"
            :fields="tableFields"
            :empty-text="$t('metrics.noTeachersFound')"
          >
            <template #cell(name)="{ item }">
              <span class="paragraph-s">{{ getMemberName(item) }}</span>
            </template>

            <template #cell(role)="{ item }">
              <span class="paragraph-s">{{ roleLabel(item.role) }}</span>
            </template>

            <template #cell(actions)="{ item }">
              <eg-button
                size="small"
                @click="$emit('view-teacher', item.clerkId)"
              >
                {{ $t("metrics.view") }}
              </eg-button>
            </template>
          </eg-pv-table>
        </div>
      </div>
    </template>
  </eg-b-sidebar>
</template>

<script>
const ROLE_LABEL_KEYS = {
  "org:admin": "metrics.adminRole",
  "org:member": "metrics.teacherRole",
};

export default {
  name: "MetricsTeachersSidebar",

  props: {
    value: {
      type: Boolean,
      default: false,
    },
    orgId: {
      type: String,
      required: true,
    },
  },

  computed: {
    tableFields() {
      return [
        { key: "name", label: this.$t("metrics.fullName") },
        {
          key: "role",
          label: this.$t("metrics.tableRole"),
          style: "width: 35%",
        },
        { key: "actions", label: "", style: "width: 20%" },
      ];
    },
    members() {
      return this.$store.state.orgUsers.users;
    },
    isLoading() {
      return this.$store.state.orgUsers.isLoading;
    },
  },

  watch: {
    value(visible) {
      // Fallback fetch in case overview didn't trigger it (e.g. direct navigation)
      if (visible && this.members.length === 0) {
        this.$store.dispatch("orgUsers/load", this.orgId);
      }
    },
  },

  methods: {
    roleLabel(role) {
      const key = ROLE_LABEL_KEYS[role];
      return key ? this.$t(key) : role;
    },

    getMemberName(member) {
      const storeUser = this.$store.state.user;
      const isCurrentUser = member.id === storeUser?.id;
      const firstName =
        member.firstName || (isCurrentUser ? storeUser?.firstName : "") || "";
      const lastName =
        member.lastName || (isCurrentUser ? storeUser?.lastName : "") || "";
      return `${firstName} ${lastName}`.trim();
    },
  },
};
</script>

<style lang="scss" scoped>
.metrics-teachers-sidebar {
  display: flex;
  flex-direction: column;
  height: 100%;

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 24px;
    border-bottom: 1px solid var(--color-stroke-neutral-default, #e5ebf0);
    flex-shrink: 0;
  }

  &__body {
    flex: 1;
    overflow-y: auto;
    padding: 24px;
  }

  &__loader {
    display: flex;
    justify-content: center;
    padding: 40px 0;
  }

  ::v-deep .p-datatable-thead th:first-child,
  ::v-deep .p-datatable-tbody > tr td:first-child {
    width: 250px;
    min-width: 250px;
  }
}
</style>
